import React, {useState, useEffect, useRef} from 'react';
import MaterialTransformInput from "../../../Reusable/NumberInputs/MaterialTransformInput.js";
import MaterialPropertiesInput from '../../../Reusable/NumberInputs/MaterialPropertiesInput.js';
import { ChromePicker } from 'react-color';
import axios from '../../../../../axios-config.js';
import Inventum from "../../../../../../engine/Inventum";

function ModelProperties (props) {
  
  let showAdvanced = false;

  if (props.siteAdmin && props.editMode) {
    showAdvanced = true;
  }

  return (
    <div style={{width:'100%', paddingBottom: '2px'}} onClick={(e) => {e.stopPropagation()}}>
      <Panel title='Material' initialOpen={true}><MaterialDrawer activeProjectID={props.activeProjectID} showAdvanced={showAdvanced} id={props.id} material={props.modelProps.material} requestedColorInput={props.requestedColorInput} colorInputRequest={props.colorInputRequest} /></Panel>
      { showAdvanced ? <Panel title='Transform' initialOpen={false}><TransformDrawer id={props.id} scale={props.modelProps.scale} position={props.modelProps.position} rotation={props.modelProps.rotation} transformActive={props.modelProps.transformActive} /></Panel> : null}
    </div>
  )
}

function Panel (props) {
  const [open, setOpen] = useState(props.initialOpen);
  return (
    <div className={open ? 'ModelPropsPanelOpen' : ''}>
      <div className='ModelPropsPanelHeader' onClick={(e) => {e.stopPropagation(); setOpen(!open)}}>
        <i className="material-icons notranslate">{open ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}</i>
        <span>{props.title}</span>
      </div>
      {open ? props.children : null}
    </div>
  )
}

function MaterialDrawer (props) {
  const material = props.material;
  const showAdvanced = props.showAdvanced;
  const [activeColorInput, setActiveColorInput] = useState(props.requestedColorInput || null);

  useEffect(() => {
    if (props.requestedColorInput) {
      setActiveColorInput(props.requestedColorInput);
    }
  }, [props.colorInputRequest, props.requestedColorInput]);

  const toggleColorInput = (key) => {
    setActiveColorInput((current) => current === key ? null : key);
  };
  const setColor = (color, opacity) => {
    const materialUpdate = {color};
    if (typeof opacity === 'number') {
      materialUpdate.opacity = opacity;
    }
    Inventum.models.setMaterial(props.id, materialUpdate);
  };
  const setEmissive = (emissive) => { Inventum.models.setMaterial(props.id, {emissive}) };
  const setOpacity = (opacity) => { Inventum.models.setMaterial(props.id, {opacity: opacity / 100}) };
  const setRoughness = (roughness) => { Inventum.models.setMaterial(props.id, {roughness: roughness / 100}) };
  const setMetalness = (metalness) => { Inventum.models.setMaterial(props.id, {metalness: metalness / 100}) };
  const setSide = (side) => { Inventum.models.setMaterial(props.id, {side})};
  const setFlat = (flatShading) => { Inventum.models.setMaterial(props.id, {flatShading})};
  const setWireframe = (wireframe) => { Inventum.models.setMaterial(props.id, {wireframe})};

  return (
    <div className='ModelPropsDrawer'>
      {material.hasOwnProperty('color') ? <ColorInput title='Color' colorKey='color' color={material.color} opacity={material.opacity} activeColorInput={activeColorInput} onToggle={toggleColorInput} onClose={() => setActiveColorInput(null)} onChange={setColor} /> : null}
      {(showAdvanced && material.hasOwnProperty('emissive')) ? <ColorInput title='Emissive' colorKey='emissive' color={material.emissive} activeColorInput={activeColorInput} onToggle={toggleColorInput} onClose={() => setActiveColorInput(null)} onChange={setEmissive} /> : null}
      {material.hasOwnProperty('opacity') ? <MaterialPropertiesInput title='Opacity' value={material.opacity * 100} onChange={setOpacity} /> : null}
      {material.hasOwnProperty('flatShading') ? <Checkbox title='Wireframe' value={material.wireframe} onChange={setWireframe} /> : null}
      {(showAdvanced && material.hasOwnProperty('metalness')) ? <MaterialPropertiesInput title='Metalness' value={material.metalness * 100} onChange={setMetalness} /> : null}
      {(showAdvanced && material.hasOwnProperty('roughness')) ? <MaterialPropertiesInput title='Roughness' value={material.roughness * 100} onChange={setRoughness} /> : null}
      {(showAdvanced && material.hasOwnProperty('side')) ? <Dropdown title='Side' items={['DoubleSide','FrontSide','BackSide']} value={material.side} onChange={setSide} /> : null}
      {(showAdvanced && material.hasOwnProperty('flatShading')) ? <Checkbox title='FlatShading' value={material.flatShading} onChange={setFlat} /> : null}
      {showAdvanced ? <ImageSelector activeProjectID={props.activeProjectID} imageURL={material.mapPath} id={props.id} /> : null}
    </div>
  );
}

function TransformDrawer (props) {
	if (props.transformActive) {
		return (
			<div className='ModelPropsDrawer' onClick={() => { Inventum.models.transformModel(props.id); }} style={{padding: '8px', backgroundColor: '#A32929', textAlign: 'center', cursor: 'pointer', borderRadius: '4px', fontSize: '12px'}}>
				Disable Gizmo to edit.
			</div>
			)
	}
  const handlePosition = (result) => {Inventum.models.transformModelNumeric(props.id, {position: result});};
  const handleRotation = (result) => {Inventum.models.transformModelNumeric(props.id, {rotation: result});};
  const handleScale = (result) => {Inventum.models.transformModelNumeric(props.id, {scale: result});};
  const resetPosition = () => {Inventum.models.resetPosition(props.id);};
  const resetRotation = () => {Inventum.models.resetRotation(props.id);};
  const resetScale = () => {Inventum.models.resetScale(props.id);};

	// WARNING: Note that the value and valueKey has a non standard order as (X Z Y).
	// The label key is unchanged. This is to label three.js Y as "Z" in the UI display
  return (
    <div className='ModelPropsDrawer'>
      <div className="ModelPropsVec3Header">
        <span className="ModelPropsVec3Label"></span>
        <div className="ModelPropsVec3Group">
          <span className="ModelPropsVec3ColHeader">X</span>
          <span className="ModelPropsVec3ColHeader">Y</span>
          <span className="ModelPropsVec3ColHeader">Z</span>
        </div>
        <div className="Vec3ResetSpacer"></div>
      </div>
      <Vec3Input label='Position' value={[props.position.x, props.position.z, props.position.y]} valueKey={['x', 'z', 'y']} onChange={handlePosition} reset={resetPosition} />
      <Vec3Input label='Rotation' value={[props.rotation.x, props.rotation.z, props.rotation.y]} valueKey={['x', 'z', 'y']} onChange={handleRotation} reset={resetRotation} />
      <Vec3Input label='Scale' value={[props.scale.x, props.scale.z, props.scale.y]} valueKey={['x', 'z', 'y']} onChange={handleScale} step={0.01} reset={resetScale} />
    </div>
  )
}

function Vec3Input (props) {
  const [x, setX] = useState(props.value[0] || 0);
  const [y, setY] = useState(props.value[1] || 0);
  const [z, setZ] = useState(props.value[2] || 0);
  const funcMap = {x: setX, y: setY, z: setZ};
  const keyMap = ['x', 'y', 'z'];

  useEffect(() => {
    if (props.value[0] !== x) setX(props.value[0]);
    if (props.value[1] !== y) setY(props.value[1]);
    if (props.value[2] !== z) setZ(props.value[2]);
  }, [props.value]);


  const handleChange = (key, value) => {
    funcMap[key](value);
    if (typeof(props.onChange) !== 'function') return;
    const result = {};
    result[props.valueKey[0]] = x;
    result[props.valueKey[1]] = y;
    result[props.valueKey[2]] = z;

    let keyIndex = keyMap.indexOf(key);
    result[props.valueKey[keyIndex]] = value;
    props.onChange(result);
  }

  return (
    <div className="ModelPropsVec3Row">
      <span className="ModelPropsVec3Label">{props.label}</span>
      <div className="ModelPropsVec3Group">
        <MaterialTransformInput value={x} valueKey={"x"} onChange={handleChange} step={props.step} />
        <MaterialTransformInput value={y} valueKey={"y"} onChange={handleChange} step={props.step} />
        <MaterialTransformInput value={z} valueKey={"z"} onChange={handleChange} step={props.step} />
      </div>
      <div className="Vec3ResetButton" onClick={props.reset}>
        <i className="material-icons notranslate">restart_alt</i>
        <span>Reset</span>
      </div>
    </div>
  );
}

function ColorInput (props) {
  const swatchColor = getColorWithAlpha(props.color, props.opacity);
  const isOpen = props.activeColorInput === props.colorKey;

  return (
    <div className={`ModelPropsColorField${isOpen ? ' is-open' : ''}`}>
      <div className='ModelPropsRow ModelPropsColorRow'>
        <span className='ModelPropsLabel'>{props.title}</span>
        <div className='ModelPropsSwatch' tabIndex={0} onClick={() => props.onToggle(props.colorKey)}>
          <SwatchColor color={swatchColor} />
          <span className='ModelPropsSwatchHex'>{swatchColor}</span>
        </div>
      </div>
      {isOpen ? <ColorSelector color={props.color} opacity={props.opacity} onChange={props.onChange} close={props.onClose} /> : null}
    </div>
  )
}

function SwatchColor (props) {
  const colorRef = useRef(null);

  useEffect(() => {
    if (colorRef.current) {
      colorRef.current.style.backgroundColor = props.color;
    }
  }, [props.color]);

  return <div className='ModelPropsSwatchColor' ref={colorRef} />;
}

function getColorWithAlpha (color, alpha) {
  if (typeof alpha !== 'number' || alpha >= 1) return color;

  const shorthandHex = /^#([a-f\d])([a-f\d])([a-f\d])$/i;
  const normalizedColor = color.replace(shorthandHex, '#$1$1$2$2$3$3');
  const hexMatch = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(normalizedColor);
  if (!hexMatch) return color;

  return `rgba(${parseInt(hexMatch[1], 16)},${parseInt(hexMatch[2], 16)},${parseInt(hexMatch[3], 16)},${alpha})`;
}

function ColorSelector (props) {
  const handleChange = (color) => {
    props.onChange(color.hex, color.rgb.a);
  };

  return (
    <div className='ModelPropsInlineColorPanel' onClick={(e) => {e.stopPropagation()}}>
      <div className='ModelPropsColorPickerWrap'>
        <ChromePicker onChange={handleChange} color={getColorWithAlpha(props.color, props.opacity)} disableAlpha={typeof props.opacity !== 'number'} />
        <button className='ModelPropsColorCloseButton' onClick={props.close}>
          <span className='material-icons'>close</span>
          Close
        </button>
      </div>
    </div>
  )
}

function Dropdown (props) {
  const handleChange = (e) => {
    if (typeof(props.onChange) === 'function') {
      props.onChange(e.target.value);
    }
  };
  return (
    <div className='ModelPropsRow'>
      <span className='ModelPropsLabel'>{props.title}</span>
      <select className='ModelPropsSelect' value={props.value} onChange={handleChange}>
        {props.items.map((item,count) => <option key={count} value={item}> {item} </option>)}
      </select>
    </div>
  )
}

function Checkbox (props) {
  const handleChange = (e) => {
    if (typeof(props.onChange) === 'function') {
      props.onChange(e.target.checked);
    }
  };
  return (
    <div className='ModelPropsRow'>
      <span className='ModelPropsLabel'>{props.title}</span>
      <label className='ModelPropsCheckbox'>
        <input name={props.title} type="checkbox" checked={props.value} onChange={handleChange}/>
        <span className='ModelPropsCheckboxIcon'>
          <i className="material-icons notranslate">{props.value ? 'check_box' : 'check_box_outline_blank'}</i>
        </span>
      </label>
    </div>
  )
}


function ImageSelector(props) {
  const [originalFileName, setOriginalFileName] = useState("");
  const [showFileName, setShowFileName] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (props.imageURL) {
      const assetIdentifier = props.imageURL.split("/").pop();
      axios
        .get(`/upload/original-filename/${assetIdentifier}`)
        .then((response) => {
          setOriginalFileName(response.data.originalFileName);
          setShowFileName(response.data.originalFileName !== "");
        })
        .catch((error) => {
          console.error("Error fetching original filename:", error);
        });
    }
  }, [props.imageURL]);

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setShowFileName(false);
      setIsLoading(true);
      setOriginalFileName(file.name);
      const form = new FormData();
      form.append("asset", file);
      form.append("projectID", props.activeProjectID);
      axios
        .post(`/upload/`, form)
        .then((response) => {
          if (response.data.url) {
            Inventum.models.setTexture(props.id, response.data.url);
            if (props.onImageUpload) {
              props.onImageUpload(response.data.url);
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Upload error:", error);
          setIsLoading(false);
        });
    }
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(originalFileName)
      .catch((error) => {
        console.error("Copy failed", error);
      });
  };

  const handleRemoveImage = () => {
    Inventum.models.clearTexture(props.id);
    setOriginalFileName("");
    setShowFileName(false);
    if (props.onImageUpload) {
      props.onImageUpload("");
    }
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <div className='ModelPropsImageSection'>
      <input
        className='ModelPropsImageInput'
        accept="image/*"
        type="file"
        onChange={onFileChange}
        ref={fileInputRef}
      />

      {isLoading && (
        <div className='ModelPropsImagePreviewArea'>
          <div className='ModelPropsImageSpinner'>
            <i className="material-icons notranslate ModelPropsSpinnerIcon">autorenew</i>
          </div>
        </div>
      )}

      {!isLoading && props.imageURL && (
        <div
          className='ModelPropsImagePreviewArea'
          style={{ backgroundImage: `url(${props.imageURL})` }}
        />
      )}

      {!isLoading && !props.imageURL && (
        <div
          className='ModelPropsImagePreviewArea ModelPropsImageEmpty'
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        >
          <i className="material-icons notranslate">add_photo_alternate</i>
          <span>Upload texture</span>
        </div>
      )}

      <div className='ModelPropsImageActions'>
        <div className='ModelPropsImageButtons'>
          <div
            className='ModelPropsImageBtn'
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
          >
            <i className="material-icons notranslate">upload</i>
            <span>Upload</span>
          </div>
          {originalFileName && (
            <div
              className='ModelPropsImageBtn'
              onClick={() => setShowFileName(!showFileName)}
            >
              <i className="material-icons notranslate">{showFileName ? 'visibility_off' : 'visibility'}</i>
              <span>{showFileName ? 'Hide name' : 'File name'}</span>
            </div>
          )}
        </div>
        {originalFileName && (
          <div
            className='ModelPropsImageBtn ModelPropsImageBtnDanger'
            onClick={handleRemoveImage}
          >
            <i className="material-icons notranslate">delete_outline</i>
            <span>Remove</span>
          </div>
        )}
      </div>

      {showFileName && originalFileName && (
        <div className='ModelPropsImageFileName'>
          <span className='ModelPropsImageFileNameText'>{originalFileName}</span>
          <div className='ModelPropsImageCopyBtn' onClick={handleCopyToClipboard}>
            <i className="material-icons notranslate">content_copy</i>
          </div>
        </div>
      )}
    </div>
  );
}

export default ModelProperties;
